import { createORPCClient, InferClientBodyInputs, InferClientBodyOutputs, onError } from '@orpc/client'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import { RPCLink } from '@orpc/client/fetch'
import { ContractRouterClient } from '@orpc/contract'
import { contract } from './contracts'

function getServerOrigin(): string {
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`
  }

  return `http://localhost:${process.env.PORT ?? '3000'}`
}

const rpcUrl = new URL(
  '/rpc',
  typeof window === 'undefined' ? getServerOrigin() : window.location.origin
).toString()

const link = new RPCLink({
  // Build an absolute same-origin URL so RPCLink can construct requests reliably.
  url: rpcUrl,
  // fetch: <-- provide fetch polyfill fetch if needed
  interceptors: [
    onError((error) => {
      console.error(error)
    })
  ],
})

// Or, create a client using a contract
export const rpcClient: ContractRouterClient<typeof contract> = createORPCClient(link)
export const rpcTanstackClient = createTanstackQueryUtils(rpcClient)

export type ClientInputs = InferClientBodyInputs<typeof rpcClient>
export type ClientOutputs = InferClientBodyOutputs<typeof rpcClient>
